module.exports = __webpack_public_path__ + "img/icon_agreement.d654c57b.png";